// extracted by mini-css-extract-plugin
module.exports = {"container":"_103a151b99--container--ZKvrF","menu_item":"_103a151b99--menu_item--Hofel"};